import { type FormEvent, useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import RightTimeApi from "@/API";
import "@style/Admin.scss";
import { toast } from "react-toastify";
import Helpers from "@/Helpers";
import { auditVersionChangesAsync } from "@/utils/versionAuditLog";

export default function Login() {
  const [email, updateEmail] = useState("");
  const [password, updatePassword] = useState("");
  const [isSubmitting, updateIsSubmitting] = useState(false);
  const submittingRef = useRef(false);
  const [code, updateCode] = useState("");
  const navigate = useNavigate();
  const [showBrowserError, updateBrowserError] = useState(false);
  const [version, updateVersion] = useState("1.1.1");
  const [showSpinner, updateSpinner] = useState(false);

  useEffect(() => {
    const webVersion = Helpers.AppVersion();
    updateVersion(webVersion);
    void auditVersionChangesAsync({ webVersion });

    const sessionExpired = window.sessionStorage.getItem("AUTH_SESSION_EXPIRED");
    if (sessionExpired === "true") {
      window.sessionStorage.removeItem("AUTH_SESSION_EXPIRED");
      toast.info("Your session has expired. Please sign in again.");
    }
  }, []);

  function onLoginResponse(resp) {
    if (resp?.jsonData?.message) {
      alert(resp.jsonData.message);
      return;
    }
    if (resp?.jsonData?.user) {
      window.sessionStorage.setItem("User", btoa(JSON.stringify(resp.jsonData.user)));
      if (resp?.jsonData?.token) window.sessionStorage.setItem("BearerToken", resp.jsonData.token);
    }
    if (resp?.jsonData?.redirect) {
      navigate(resp.jsonData.redirect);
    }
  }

  // async function LoginViaCodeAsync() {
  //   if (userCode) {
  //     const resp = RightTimeApi.postAsync("/Login", { userCode: userCode });
  //     if (resp && resp.ok) {
  //       onLoginResponse(resp);
  //     }
  //   }
  // }

  function onChange(e: any) {
    if (e && e.target && e.target.name) {
      switch (e.target.name.toLowerCase()) {
        case "email":
          updateEmail(e.target.value);
          break;
        case "password":
          updatePassword(e.target.value);
          break;
        case "code":
          updateCode(e.target.value);
          break;
        default:
          break;
      }
    }
  }

  async function onLoginAsync(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    // State updates land on the next render, so a ref is needed to block a second submit fired before then.
    if (submittingRef.current) return;
    submittingRef.current = true;
    updateIsSubmitting(true);
    const data = { email: email, password: password, code: code };
    try {
      updateSpinner(true);
      sessionStorage.clear();
      const resp = await RightTimeApi.postAsync("/Login", data);
      updateSpinner(false);
      if (resp?.ok) onLoginResponse(resp);
      else {
        if (resp?.status === 401) toast.error("Incorrect credentials");
        if (resp?.status === 404) navigate("/pages/Login404");
      }
    } catch (error) {
      console.error("Error connecting to the server calling /Login", error);
      toast.error("Could not connect to the server. Please try again later.");
    } finally {
      submittingRef.current = false;
      updateIsSubmitting(false);
      updateSpinner(false);
    }
  }

  // console.log("Got to Login");
  return (
    <>
      <div className="pageContent loginPage">
        <div className="versionDisplay">{version}</div>
        {showBrowserError ? (
          <div className="error">This website does not support old browsers. Please upgrade!</div>
        ) : (
          <form className="loginForm" onSubmit={onLoginAsync}>
            <div className="field hide-lastpass">
              <input
                type="email"
                name="email"
                value={email}
                onChange={onChange}
                data-lpignore="true"
                autoComplete="off"
                placeholder="Email"
              />
            </div>
            <div className="field hide-lastpass">
              <input
                type="password"
                name="password"
                value={password}
                onChange={onChange}
                data-lpignore="true"
                autoComplete="off"
                placeholder="Password"
              />
            </div>
            <div className="actions">
              <button type="submit" className="loginSubmitButton" disabled={isSubmitting}>
                Login
              </button>
            </div>
          </form>
        )}
      </div>
      {
        showSpinner && (
          <div className="overlay">
            <div className="spinner"></div>
          </div>
        )
      }
    </>
  );
}

